"use client";

import { ToastContainer } from "react-toastify";
import { useTheme } from "next-themes";

export const ThemedToastContainer = () => {
    const { resolvedTheme } = useTheme(); // Get current theme from next-themes
    const isDarkMode = resolvedTheme === "dark";

    return (
        <ToastContainer
            theme={isDarkMode ? "dark" : "light"} // Set theme based on current mode
        />
    );
};


